import { useState } from 'react'
import { CurecallModalContainer, CurecallTab } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { ExistingMedAlertTab } from './existing-med-alert-form.component'
import { NewMedAlertForm } from './new-med-alert-form.component'

interface SelectOrAddMedAlertModalProps {
  isOpen: boolean
  onCancel: () => void
  onValidate: (medAlertId: number) => void
  responseContext?: 'yes' | 'no'
}

type TTabId = 'existing' | 'new'

export function SelectOrAddMedAlertModal({
  isOpen,
  onCancel,
  onValidate,
  responseContext,
}: SelectOrAddMedAlertModalProps) {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState<TTabId>('existing')

  const responseSubtitle = responseContext
    ? t(`pages.configuration.followups.chatbot.med-alert-modal.for-response-${responseContext}`)
    : undefined

  return (
    <CurecallModalContainer
      closeModalAriaLabel={t('common.actions.cancel')}
      isOpen={isOpen}
      toggle={onCancel}
      title={
        <div>
          {t('pages.configuration.followups.chatbot.med-alert-modal.add-med-alert-title')}
          <br />
          <div className="c-font-medium c-text-sm">{responseSubtitle}</div>
        </div>
      }
      dialogClassName="c-w-[700px]"
    >
      <div className="c-flex c-flex-col c-gap-4">
        <div className="c-flex c-gap-[10px] c-border-b c-border-gray-300">
          <CurecallTab
            isActive={activeTab === 'existing'}
            onClick={() => setActiveTab('existing')}
            className="c-flex-1"
            buttonClassName="c-flex-1 c-justify-center"
          >
            {t('pages.configuration.followups.chatbot.med-alert-modal.use-existing-med-alert')}
          </CurecallTab>
          <CurecallTab
            isActive={activeTab === 'new'}
            onClick={() => setActiveTab('new')}
            className="c-flex-1"
            buttonClassName="c-flex-1 c-justify-center"
          >
            {t('pages.configuration.followups.chatbot.med-alert-modal.create-new-med-alert')}
          </CurecallTab>
        </div>

        {activeTab === 'existing' ? (
          <ExistingMedAlertTab
            key="existing"
            onCancel={onCancel}
            onValidate={onValidate}
            onSwitchToNewMedAlert={() => setActiveTab('new')}
          />
        ) : (
          <NewMedAlertForm key="new" onCancel={onCancel} onValidate={onValidate} />
        )}
      </div>
    </CurecallModalContainer>
  )
}
